import React, { useContext } from 'react';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';

import { MessageContext } from '../../contexts/messageContext';
import { GET_USERS_BY_FILTER_QUERY } from '../../graphql/GET_USERS_BY_FILTER_QUERY';
import { GET_USER_getUser } from '../../graphql/types/GET_USER';
import { useAutocomplete } from '../../hooks/useAutocomplete';
import SearchIcon from '../../assets/svg/search.svg';

const MessageUserSearch = () => {
  const { actions } = useContext(MessageContext);

  const usersOptsSelectCb = async (otherUser: GET_USER_getUser) => {
    if (!otherUser) {
      return;
    }
    await actions.handleSelectOtherUser(otherUser);
  };

  const { loadOptions, loading, responseData } = useAutocomplete({
    query: GET_USERS_BY_FILTER_QUERY
  });

  const CustomPlaceholder = (props: any) => {
    return (
      <components.Placeholder {...props}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px', opacity: 0.5 }} />
          <span>{props.children}</span>
        </div>
      </components.Placeholder>
    );
  };

  return (
    <AsyncSelect
      backspaceRemovesValue={true}
      cacheOptions={true}
      className="custom-select is-small auto-complete"
      defaultOptions={true}
      escapeClearsValue={true}
      getOptionLabel={option => option.profile.name}
      getOptionValue={option => option.profile.id}
      isClearable={true}
      isLoading={loading}
      loadOptions={loadOptions}
      onChange={usersOptsSelectCb}
      options={responseData}
      placeholder="Field, Name, Location"
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        Placeholder: CustomPlaceholder
      }}
      value={null}
    />
  );
};

export default MessageUserSearch;
